// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1z-6";
export var headerCell = "_1z-2";
export var rowWrapper = "_1z-4";
export var stickyAggregationCell = "_1z-a";
export var stickyAggregationRow = "_1z-7";
export var stickyColumnCell = "_1z-9";
export var stickyColumnHeaderCell = "_1z-8";
export var table = "_1z-1";
export var virtualRowWrapper = "_1z-5";
export var virtualTableContainer = "_1z-0";
export var white = "_1z-3";